const DEFAULT_TRACKING_DATA = {
    user_platform: 'website',
    page_category: 'Marketing Landing Page',
    page_subcategory: '',
    platform_version: 'new',
    site_section: 'Marketing pages',
};

export const defaultTrackingData = DEFAULT_TRACKING_DATA;
